import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from '@ex/module/core/domain/base-component';
import { AnnouncementsService } from '@ex/culture/announcements';
import { DATA_TOKEN } from '@ex/module/shared/Theme/services/zen-cdk.service';

@Component({
  selector: 'app-culture-launch-announcements',
  templateUrl: './culture-launch-announcements.component.html',
  styleUrl: './culture-launch-announcements.component.scss'
})
export class CultureLaunchAnnouncementsComponent extends BaseComponent {
  open = true;
  language: string;

  readonly points = ['cultureLaunchPoint1', 'cultureLaunchPoint2', 'cultureLaunchPoint3'];
  readonly image = 'assets/announcements/culture.png';

  @Output() close: EventEmitter<any> = new EventEmitter();
  @Output() results: EventEmitter<any> = new EventEmitter();

  constructor(
    @Inject(DATA_TOKEN) private data: any,
    private router: Router,
    private announcements: AnnouncementsService,
  ) {
    super();
    this.language = this.data?.essentialObject?.language || 'EN';
  }

  explore() {
    if (!this.open) return;
    this.open = false;

    const finish = () => {
      this.router.navigate(['/culture/home']);
      this.results.emit({ dismissed: true });
      this.close.emit(true);
    };

    const essential = this.data?.essentialObject;
    const tenantName = essential?.tenant?.name || essential?.selectedEntity?.nativeName;
    if (!tenantName) {
      finish();
      return;
    }

    // Navigate only after the Culture API call settles so overlay detach
    // cannot cancel the request mid-flight.
    this.announcements.notifyInterest({ tenantName }).subscribe({
      next: () => finish(),
      error: () => finish(),
    });
  }

  // Every exit route funnels through here so the service's write-on-dismiss fires
  // whether the user takes the CTA, defers, or clicks the backdrop. `results` is
  // what openComponent hands back to the caller; `close` tears the overlay down.
  dismiss() {
    if (!this.open) return;
    this.open = false;
    this.results.emit({ dismissed: true });
    this.close.emit(true);
  }
}
